import React from 'react'

import styled from '@emotion/styled'

export type ButtonlessProps = React.ButtonHTMLAttributes<HTMLButtonElement>

/**
 * A completely unstyled button component that removes all default button styling
 * while maintaining accessibility and basic interactive behavior.
 */
const Buttonless = styled.button<ButtonlessProps>`
  background: none;
  border: none;
  color: inherit;
  cursor: pointer;
  font: inherit;
  outline: inherit;
  text-align: left;
  padding: ${({ theme }) => theme.spacing.empty};
  user-select: none;
  vertical-align: middle;

  ${({ theme }) => theme.selectors.keyboard} &:focus {
    border-radius: 0.5rem;
    outline: 0.5rem solid ${({ theme }) => theme.addOpacity(theme.colors.inputFocusBorder, 0.2)};
  }

  &:disabled {
    cursor: not-allowed;
  }
`

export default Buttonless
